import React from 'react';
interface FreeConsultLinkProps {
  children: React.ReactNode;
  onClick: () => void;
}
export const FreeConsultLink: React.FC<FreeConsultLinkProps> = ({
  children,
  onClick
}) => {
  return <a href="https://training.stresslessdogs.nl/va-video" className="text-blue-600 cursor-pointer hover:underline" onClick={e => {
    e.preventDefault();
    onClick();
  }} data-id="element-201">
      {children}
    </a>;
};